import { AI_TUTOR_ID, AI_TUTOR_USER_ID } from "@/constants/settings.ts";

export const INVALID_TUTOR_ID = -0xdeadbeef;

export const isInvalidTutorId = (tutorId?: number | null): boolean =>
  tutorId != null && tutorId === INVALID_TUTOR_ID;

export const IsAiTutorUserId = (tutorId?: number | null): boolean =>
  AI_TUTOR_USER_ID !== undefined && tutorId != null && tutorId === AI_TUTOR_USER_ID;

export const IsAiTutorId = (userId?: number | null): boolean =>
  AI_TUTOR_ID !== undefined && userId != null && userId === AI_TUTOR_ID;
